import { Pages } from "./types";

export const enum AnalyticsPageResources {
  ResourcesRoot = "ResourcesRoot",
  StackIacManagement = "StackIacManagement",
  AccountIacManagement = "AccountIacManagement",
  ConfigurationManagement = "ConfigurationManagement",
  Scans = "Scans",
}

const RESOURCES_TITLE = "Resources";

export const pagesResources: Pages<AnalyticsPageResources> = {
  [AnalyticsPageResources.ResourcesRoot]: [RESOURCES_TITLE],
  [AnalyticsPageResources.StackIacManagement]: ["Stack", "IaC management"],
  [AnalyticsPageResources.AccountIacManagement]: [RESOURCES_TITLE, "IaC management"],
  [AnalyticsPageResources.ConfigurationManagement]: [RESOURCES_TITLE, "Configuration management"],
  [AnalyticsPageResources.Scans]: [RESOURCES_TITLE, "Scans"],
};
